var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control-next-icon{background-image:url(" + escape(require("../../assets/images/pijl-rechts.png")) + ");height:36px}.carousel-control-prev-icon{background-image:url(" + escape(require("../../assets/images/pijl-links.png")) + ");height:36px}#homeSlider .carousel-caption{bottom:20px;top:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68064ca8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/carousel.vue
// module id = 575
// module chunks = 0